export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5327.3c78ec27.jpg";